<template>
  <div class="flex flex-wrap items-center">
    <div
      class="flex flex-wrap items-center"
      :class="{
        'is-closed': !isOpened
      }"
    >
      <div
        v-for="(facet, index) in model"
        :key="index"
        class="inline-flex items-center related-facet"
      >
        <a
          class="text-xs underline hover:no-underline"
          :href="facet.url"
          @click.prevent="onClick(facet)"
        >
          {{ facet.title || facet.slug }}
        </a>
        <span
          v-if="index !== model.length - 1"
          class="text-2xs text-center w-4"
        >&bull;</span>
      </div>
      <span
        v-if="!isOpened && isMoreButtonNeeded"
        class="inline-flex items-center text-xs"
        role="button"
        @click="showAll"
      >
        {{ seeMoreFacets }}
        <span
          class="text-3xs"
          :class="{
            'icon-chevron-right ml-1': dir === 'ltr',
            'icon-chevron-left mr-1': dir === 'rtl'
          }"
        />
      </span>
    </div>
  </div>
</template>

<script>
import store from '@/components/facet/store'
import updateUrl from '@/components/facet/update-url'
import tracking from '@/helpers/tracking'


export default {
  props: {
    model: {
      type: Array,
      default: () => []
    },
    seeMoreFacets: {
      type: String,
      default: ''
    },
    facetName: {
      type: String,
      default: ''
    },
    dir: {
      type: String,
      default: 'rtl'
    }
  },
  data() {
    return {
      store,
      isOpened: false
    }
  },
  computed: {
    isMoreButtonNeeded() {
      return this.model.length > 5
    }
  },
  methods: {
    showAll() {
      this.isOpened = true
    },
    async onClick(facet) {
      store.dispatch('showLoader')
      store.dispatch('setTags', { tags: facet.fullContentCriteriaTags })
      const { facetName } = this
      tracking.relatedFacetSlider({
        facetName,
        relatedFacetName: facet.title || facet.slug,
        placement: 'facet related recipes slider'
      })
      const { tagUids } = this.store.getters
      this.store.dispatch('resetCards')
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      await this.store.dispatch('loadCards', { tagUids })
      const { state } = this.store
      updateUrl.save(state)
      this.store.dispatch('hideLoader')
    }
  }
}
</script>

<style scoped>
.is-closed .related-facet:nth-child(n + 6) {
  display: none;
}
</style>
